/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const idMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',

  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */

  'dashboards.update': 'Perbarui',
  'dashboards.save': 'Simpan',
  'dashboards.saveSchedule': 'Simpan Jadwal',
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Tiket',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': 'Jumlah tiket',
  'dashboards.commonticketsubmission': 'Pengiriman tiket umum',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.connect': 'Hubungkan',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'Negara',
  'dashboards.webVisitors': 'Pengunjung Web',
  'dashboards.avatarClicks': 'Klik Avatar',
  'dashboards.wordCloud': 'Awan Kata',
  'dashboards.topic': 'Topic',
  'dashboards.name': 'Nama',
  'dashboards.button': 'Tombol',
  'dashboards.visits': 'Kunjungan',
  'dashboards.checkAvailability': 'Periksa Ketersediaan atau Tarif',
  'dashboards.details': 'Rincian',
  'dashboards.roomsAvailability': 'Kamar & Ketersediaan',
  'dashboards.startChat': 'Mulai Obrolan',
  'dashboards.restaurantsBars': 'Restoran & Bar',
  'dashboards.groupBooking': 'Pemesanan Grup',
  'dashboards.promotions': 'Promosi',
  'dashboards.weedingevents': 'Pernikahan & Acara',
  'dashboards.lostsomething': 'Kehilangan Sesuatu',
  'dashboards.producttext': 'Teks Produk',
  'dashboards.bookingroomnew': 'Pemesanan Kamar Baru',
  'dashboards.email': 'Email',
  'dashboards.phone': 'Telepon',
  'dashboards.zipcode': 'Kode Pos',
  'dashboards.marketingconsent': 'Persetujuan Pemasaran',
  'dashboards.additionalinfo': 'Info Tambahan',
  'dashboards.viewallcontacts': 'Lihat Semua Kontak',
  'dashboards.current': 'Saat Ini',
  'dashboards.last7days': '7 Hari Terakhir',
  'dashboards.last30days': '30 Hari Terakhir',
  'dashboards.thisweek': 'Minggu Ini',
  'dashboards.thismonth': 'Bulan Ini',
  'dashboards.previousmonth': 'Bulan Sebelumnya',
  'dashboards.yeartodate': 'Tahun sampai hari ini',
  'dashboards.lastyear': 'Tahun Lalu',
  'dashboards.all': 'Semua',
  'dashboards.standardOccupancy': 'Kapasitas Standar',
  'dashboards.max-occupancy': 'Kapasitas Maksimum',
  'dashboards.numberOfThisType': 'Jumlah Tipe Ini',
  'dashboards.displayOrder': 'Urutan Tampilan',
  'dashboards.provider': 'Penyedia',
  'dashboards.edit': 'Edit',
  'dashboards.delete': 'Hapus',
  'dashboards.addImages': 'Tambahkan Gambar',
  'dashboards.location_ip': 'Lokasi perkiraan berdasarkan alamat IP',
  'dashboards.near': 'Dekat',
  'dashboards.referral':
    'Pengguna diarahkan ke halaman Anda oleh situs web ini',
  'dashboards.calling_party': 'Pengguna pemanggil',
  'dashboards.called_party': 'Pengguna yang dipanggil',
  'dashboards.lastdial': 'Panggilan terakhir',
  'dashboards.imagelink': 'Tautan gambar',
  'dashboards.browsegallery': 'Telusuri galeri',
  'dashboards.changelog': 'Log Perubahan',
  'dashboards.externalresources': 'Sumber Eksternal',
  'dashboards.webpage': 'Halaman Web',
  'dashboards.web-pages': 'Halaman Web',
  'dashboards.published': 'Dipublikasikan',
  'dashboards.adddocument': 'Tambahkan Dokumen',
  'dashboards.ready-to-publish': 'Siap Diterbitkan',
  'dashboards.draft': 'Draf',
  'dashboards.order-by': 'Urutkan berdasarkan',
  'dashboards.add-faq': 'Tambahkan FAQ',
  'dashboards.collections': 'Koleksi',
  'dashboards.items': 'Item',
  'dashboards.rooms-availability': 'Kamar & Ketersediaan',
  'dashboards.events-wedding-venues': 'Acara & Tempat Pernikahan',
  'dashboards.long-stay-enquiry': 'Permintaan Menginap Lama',
  'dashboards.reservation-confirmation-request':
    'Permintaan Konfirmasi Reservasi',
  'dashboards.modify-cancel-booking': 'Ubah atau Batalkan Pemesanan',
  'dashboards.left-something-behind': 'Tertinggal Sesuatu',
  'dashboards.invoice-copy': 'Salinan Faktur / Tanda Terima',
  'dashboards.sync': 'Sinkronkan',
  'dashboards.syncNow': 'Sinkronkan Sekarang',
  'dashboards.add-web-page': 'Tambah Halaman Web',
  'dashboards.sprint-title':
    'Temui Sprint, otomasi terobosan kami untuk melatih model AI dalam waktu 10× lebih cepat.',
  'dashboards.sprint-description':
    'Sprint bekerja bersama Anda—untuk membebaskan kreativitas, membuka produktivitas, dan secara drastis mengurangi waktu yang dibutuhkan untuk melatih Asisten Digital.',
  'dashboards.sprint-feature':
    'Fitur Sprint dirancang untuk menyinkronkan pengetahuan dari sumber eksternal, membuatnya berharga baik untuk penyiapan awal maupun pembaruan data berkelanjutan. Ketika dijalankan di sistem aktif, Sprint memodifikasi Knowledge Hub berdasarkan sumber eksternal yang Anda konfigurasikan, yang dapat langsung memengaruhi perilaku dan respons yang dihasilkan AI. Untuk bantuan pengaturan Sprint, silakan hubungi tim dukungan kami.',
  'dashboards.change-password': 'Ganti Kata Sandi',
  'dashboards.sign-out': 'Keluar',
  'dashboards.privacy-policy': 'Kebijakan Privasi',
  'dashboards.help-center': 'Pusat Bantuan',
  'dashboards.switch-account': 'Ganti Akun',
  'dashboards.business-settings': 'Pengaturan Bisnis',
  'dashboards.notifications-allowed': 'Notifikasi Diizinkan',
  'dashboards.dark-theme': 'Tema Gelap',
  'dashboards.online': 'Online',
  'dashboards.offline': 'Offline',
  'dashboards.invoice-&-payments': 'Faktur & Pembayaran',
  'dashboards.upgrade-plan': 'Tingkatkan Paket',
  'dashboards.add-room': 'Tambahkan Kamar',
  'dashboards.room-type': 'Jenis Kamar',
  'dashboards.room-name': 'Nama Kamar',
  'dashboards.how-many-guests': 'Total Tamu Per Kamar',
  'dashboards.number-of-rooms-this-type': 'Jumlah Kamar',
  'dashboards.number-of-bedrooms': 'Jumlah kamar tidur',
  'dashboards.number-of-livingrooms': 'Jumlah ruang tamu',
  'dashboards.minimum-adults': 'Minimal Dewasa',
  'dashboards.maximum-adults': 'Maksimal Dewasa',
  'dashboards.maximum-children': 'Maksimal Anak',
  'dashboards.maximum-infants': 'Maksimal Bayi',
  'dashboards.extra-beds-allowed': 'Izinkan tempat tidur tambahan',
  'dashboards.booking-engine-code': 'Kode Mesin Pemesanan',
  'dashboards.room-size': 'Ukuran Kamar',
  'dashboards.balcony-area': 'Luas Balkon',
  'dashboards.unit': 'Unit',
  'dashboard.whatsapp_message': 'Ketik pesan Anda di sini...',
  'dashboard.whatsapp_reply_window':
    'Anda memiliki jendela waktu 24 jam untuk membalas pesan pelanggan di WhatsApp Business sejak pesan terakhir dikirim oleh pelanggan. Jika Anda membalas dalam jendela layanan pelanggan 24 jam ini, Anda dapat mengirim jenis pesan apa pun. Setelah jendela 24 jam ditutup, Anda hanya dapat mengirim pesan menggunakan Template Pesan yang telah disetujui sebelumnya, yang akan memulai ulang jendela 24 jam ketika pelanggan merespons.',
  'dashboards.square-meters': 'Meter Persegi',
  'dashboard.pick_quick_reply': 'Pilih balasan cepat atau ketik pesan Anda',
  'dashboard.hang_in_there':
    'Mohon tunggu sementara kami mencoba menghubungkan Anda!',
  'dashboard.outbound_msg': 'Waktu pengiriman pesan keluar',
  'dashboard.message_sent': 'Pesan Anda berhasil dikirim!',
  'dashboard.failed_msg': 'Gagal mengirim pesan',
  'dashboard.new_chat_message': 'Pesan obrolan baru',
  'dashboard.user_msg':
    'Ada pesan dari pengguna dalam 24 jam terakhir. Anda dapat mengirim pesan apa pun sebagai balasan. Apakah Anda masih ingin mengirim pesan template ini atau membalas dengan pesan lain?',
  'dashboard.us_number':
    'Pesan WhatsApp Business tidak dikirim ke nomor AS karena Meta menghentikan semua pesan pemasaran ke nomor AS pada 1 April 2025.',
  'dashboard.error_msg': 'Harap lengkapi semua placeholder dengan benar.',

  'web-widget.title': 'Menu Widget Web untuk Chatbot Situs Web',
  /*Home page*/
  'dashboards.quickstartwithai': 'Mulai Cepat dengan AI',
  'dashboards.fastestpathtoautomation':
    'Anda berada di jalur tercepat menuju otomasi dengan alat AI',
  'dashboards.insightsthatempower': 'Wawasan yang Memberdayakan',
  'dashboards.trainchatbot': 'Latih Chatbot',
  'dashboards.automatewithforms': 'Otomatisasi dengan Formulir',
  'dashboards.inroomdigitalcompendium': 'Kompendium Digital di Dalam Kamar',
  'dashboards.support': 'Dukungan',
  'dashboards.helpcenter': 'Pusat Bantuan',
  'dashboards.searchfaqintegrations':
    'Cari artikel tentang FAQ umum, integrasi dan lainnya.',
  'dashboards.asklivechat': 'Tanyakan pertanyaan ke tim kami di Live Chat',
  'dashboards.inroomqrcode':
    'Kode QR di dalam kamar untuk melihat info tentang properti dan lokasi',
  'dashboards.customizewebwidget':
    'Sesuaikan dan tambahkan Widget Web ke situs Anda dengan Chatbot AI terintegrasi',
  'dashboards.createcustomforms':
    'Buat formulir khusus dan dapatkan notifikasi saat tamu mengirimkan formulir',
  'dashboards.trainchatbotproperty':
    'Latih Chatbot dengan info properti Anda seperti jam check‑in, aktivitas, dll.',
  'dashboards.chatbotinsights':
    'Lihat bagaimana Chatbot Anda berinteraksi dengan tamu dan dapatkan wawasan statistik seperti pengunjung situs web, pertanyaan umum, dan banyak lagi.',
  'dashboards.addaichatbottoyourwebsite':
    'Tambahkan Chatbot AI ke Situs Web Anda',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Ringkasan Thread',
  'dashboards.thread-summary-subtitle': 'Ringkasan email yang dibuat oleh AI',
  'dashboards.ai-replies-title': 'Balasan AI',
  'dashboards.ai-replies-subtitle': 'Balasan yang dibuat oleh AI',
  'dashboards.total-thread-summary-title':
    'Jumlah Total Ringkasan Thread yang Dibuat',
  'dashboards.total-ai-replies-title': 'Jumlah Total Balasan AI yang Dibuat',
  'dashboards.total-draft-copied': 'Draft Disalin oleh Pengguna',
  'dashboards.urgency': 'Urgensi',
  'dashboards.sentiment': 'Sentimen',
  'dashboards.common-email-reasons': 'Alasan Umum Email',
  'dashboards.topics-in-emails': 'Topik dalam Email',
  'dashboards.email-assistant-usage': 'Penggunaan Asisten Email AI',
  'dashboards.usage-by-email-address': 'Penggunaan berdasarkan Alamat Email',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Pesan',
  'chat.contacts': 'Kontak',
  'chat.saysomething': 'Katakan sesuatu..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  'property-info.allcustomers': 'Semua pelanggan',
  'property-info.external-sources': 'Sumber Eksternal',
  'property-info.faq': 'Pertanyaan yang Sering Diajukan',
  'property-info.documents': 'Dokumen',
  'property-info.publish-ai': 'Publikasikan dengan AI',
  'property-info.pre-built-templates': 'Template Siap Pakai',
  'property-info.room-types': 'Jenis Kamar',

  'property-info.about-property': 'Tentang Properti',
  'property-info.about-properties': 'Tentang Properti',
  'property-info.facilities-services': 'Fasilitas & Layanan',
  'property-info.property-facilities': 'Fasilitas Properti',
  'property-info.room-amenities': 'Fasilitas Kamar',
  'property-info.property-contact': 'Kontak Properti',
  'property-info.property-activities': 'Aktivitas Properti',
  'property-info.property-location': 'Lokasi Properti',
  'property-info.about-rooms': 'Tentang Kamar',
  'property-info.about-sites': 'Tentang Situs',
  'property-info.special-emergencies': 'Darurat',
  'property-info.gallery': 'Galeri',
  'property-info.policies': 'Kebijakan',
  'property-info.nearby': 'Di dekat sini',
  'property-info.transport': 'Mengangkut',
  'property-info.location': 'Lokasi',
  'property-info.about-rhproperty': 'Tentang Rumah Pensiun',
  'property-info.related-topics': 'Topik-topik yang berkaitan',
  'property-info.assistant-options': 'Opsi Asisten',
  'property-info.restaurant-assistant-information': 'Informasi Restoran',
  'property-info.restaurant-assistant-options': 'Pesan Selamat Datang',
  'property-info.channel-messages': 'Pesan Saluran',
  'property-info.icon.gallery': 'Galeri Ikon',
  'property-info.copilot': 'Kopilot',
  'property-info.sprint': 'Lari cepat',
  'property-info.home-information': 'Informasi Rumah',
  'property-info.loction': 'Lokasi',
  'property-info.rooms-and-images': 'Kamar & Gambar',
  'property-info.trainig-data': 'Data pelatihan',
  'property-info.flows': 'Arus',
  'property-info.add-your-own': 'Tambahkan Milik Anda',
  'property-info-utility-miscellaneous': 'Aneka ragam',
  'property-info-utility-payment': 'Pembayaran',
  'property-info-utility-broadband': 'pita lebar',
  'property-info-utility-emergency': 'Keadaan darurat',
  'property-info-utility-mobile': 'Seluler',
  'property-info-utility-moving': 'Bergerak',
  'property-info.publishMonitor': 'Terbitkan & Pantau',
  'property-info.webWidget': 'Widget Web',
  'property-info.media': 'Media',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Paket Tarif',
  'rate-promo.rate-plan-addons': 'Add-on',
  'rate-promo.rate-plan-promos': 'Promo',

  'title.property-information': 'Informasi Properti',

  'property.message': 'Pesan',
  'property.example': 'Contoh',
  'property.link': 'Tautan',
  'property.image-carousel': 'Korsel Gambar',
  'property.Title': 'Judul',
  'property.SubTitle': 'Sub Judul',

  'property.add-invoke-api': 'Panggil Api',
  'property.add-message-button': 'Tambahkan Pesan',
  'property.add-img-button': 'Tambahkan Gambar',
  'property.add-link-button': 'Tambahkan Tautan',
  'property.add-herocard-button': 'Tambahkan Kartu Pahlawan',
  'property.add-api-button': 'Tambahkan Tombol',

  'menu.settings': 'Pengaturan',
  'menu.workflows': 'Alur Kerja',
  'menu.product_services': 'Produk & Layanan',
  'menu.product_recommander': 'Pemberi Rekomendasi Produk',
  'menu.digital_guide_book': 'Buku Panduan Digital',
  'menu.welcome_message': 'Pesan Selamat Datang',
  'menu.about-property': 'Tentang Properti',
  'menu.property-facilities': 'Fasilitas Properti',
  'menu.room-amenities': 'Fasilitas Kamar',
  'menu.property-contact': 'Kontak Properti',
  'menu.about-rooms': 'Kamar',
  'menu.special-emergencies': 'Keadaan Darurat',
  'menu.show-filter': 'Filter',
  'menu.new': 'Baru',
  'menu.channel': 'Saluran',
  'menu.application': 'Aplikasi',
  'menu.content-manager': 'Manajer Konten',
  'menu.events-calendar': 'Kalender Acara',
  'menu.appearance-settings': 'Tampilan & Pengaturan',

  'dashboards.send': 'Kirim',
  'dashboards.hello': 'Halo',
  'dashboards.notificationsAllowed': 'Notifikasi Diizinkan',
  'dashboards.allowNotifications': 'Izinkan Notifikasi',
  'dashboards.views': 'Tampilan',
  'dashboards.bookingURL': 'URL Pemesanan',
  'dashboards.searchTags': 'Tag Pencarian',
  'dashboards.searchCategoryTags': 'Tag Kategori Pencarian',
  'dashboards.bedroom': 'Kamar tidur',
  'dashboards.addBedroom': 'Tambah kamar tidur',
  'dashboards.frequency': 'Frekuensi',
  'dashboards.includeSubpages': 'Sertakan Subhalaman',
  'dashboards.enableFaqs': 'Aktifkan FAQ',
  'dashboards.faqsDescription':
    'Mengaktifkan FAQ memungkinkan Anda memasukkan pertanyaan sementara sistem mengekstrak jawaban yang sesuai dari konten halaman web untuk membuat FAQ lengkap',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Hapus Dokumen',
  'dashboards.confirmDelete': 'Apakah Anda yakin ingin menghapus?',
  'dashboards.addItem': 'Tambahkan Item',
  'dashboards.addFirstWebPage': 'Tambahkan Halaman Web Pertama Anda',

  'dashboards.popular-compendium': 'Item Menu Kompendium Populer',
  'dashboards.wordcloudofcompendium': 'Word Cloud untuk Item Menu Kompendium',
  'dashboards.wordcloudonthings':
    'Word Cloud tentang Pertanyaan Pengunjung Website & Item Menu',
  'dashboards.common-asked': 'Pertanyaan Umum',
  'dashboards.website-visitor-asking':
    'Hal-hal yang Ditanyakan Pengunjung Situs Web',
  'dashboards.visit-country': 'Kunjungan Situs Web menurut Negara',
  'dashboards.visit-traffic': 'Negara Lalu Lintas Situs Web',
  'dashboards.rooms-product': 'Kamar & Produk',
  'dashboards.popular-room-product': 'Kamar dan produk populer',

  'dashboards.messenger-stats': 'Item Menu Populer',
  'dashboards.messenger-stats-topic-view': 'Statistik pada Tampilan Item Menu',
  'dashboards.messenger-stats-visits': 'Tampilan Item Menu',
  'dashboards.opening-menu-items':
    'Jumlah Pengunjung Situs Web yang membuka Item Menu',
  'dashboards.tickets-by-category': 'Tiket menurut Kategori',
  'dashboards.download': 'Unduh',
  'dashboards.number-totalavatarclick': 'Jumlah Klik Avatar',
  'dashboards.subscribe-to-reports': 'Berlangganan Laporan',
  'dashboards.clicks': 'Klik',
  'dashboards.leads': 'Memimpin',
  'dashboards.hours': 'Jam',
  'dashboards.minutes': 'Menit',

  'dashboards.ai-chatbot': 'AI Obrolan',
  'dashboards.compendium': 'Ringkasan',
  'dashboards.compendium-digital-usage': 'Penggunaan Ringkasan Digital',
  'dashboards.compendium-unique-visits': 'Pemindaian/klik kode QR',
  'dashboards.compendium-opening-menu-items': 'Jumlah item menu yang dilihat',
  'dashboards.compendium-total-digital-clicks': 'Total Tampilan Item Menu',
  'dashboards.compendium-total-qr-code': 'Total Pemindaian/Klik Kode QR',
  'dashboards.compendium-avg-menu-items':
    'Rata-rata Tampilan Item Menu Per Pemindaian',
  'dashboards.top-clicked-urls': 'URL yang paling banyak diklik',
  'dashboards.top-clicked-urls-description': 'Analisis klik URL',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    'Dokumen ini dibuat dari sumber eksternal. Jika Anda tidak ingin dokumen ini dibuat ulang, pastikan juga untuk menghapus jadwal sinkronisasi terkait.',
  'dashboards.deleteAndGoToExternalSources':
    'Hapus dan pergi ke Sumber Eksternal',
  'property.delete': 'Menghapus',
  'menu.userroles': 'Pengguna & Peran',
  'menu.members': 'Anggota',
  'menu.guest-pass': 'Kartu Tamu',
  'menu.ratebookings': 'Tarif & Pemesanan',
  'dashboards.engagement-time': 'Waktu Keterlibatan Asisten Digital',
  'dashboards.conversations-minutes':
    'Total Menit & Semalam (19.00 hingga 07.00) Menit Percakapan',
  'dashboards.conversations': 'Conversations',
  'dashboards.total-messages': 'Total Messages',
  'dashboards.visitor-questions': 'Pertanyaan Pengunjung',
  'dashboards.recent-queries': 'Kueri Terbaru',
  'dashboards.visitor-saying':
    'Apa yang dikatakan pengunjung Anda kepada Asisten Digital',
  'dashboards.contacts-prechatform-leavemessage':
    'Kontak Tersimpan dari Formulir Pra Obrolan & Tinggalkan Pesan',
  'menu.dashboards': 'Wawasan',
  'menu.ari': 'Ketersediaan & Tarif',
  'menu.conversations': 'Percakapan',
  'menu.conversations.unified-inbox': 'Kotak Masuk Terpadu',
  'menu.conversations.active': 'Obrolan Aktif',
  'menu.conversations.archives': 'Arsip',
  'menu.conversations.missed-responses': 'Tanggapan yang terlewatkan',
  'menu.conversations.ticket': 'Tiket',
  'menu.conversations.reply-templates': 'Templat Balas',
  'menu.bookings': 'Reservasi & Pemesanan',
  'menu.tickets': 'Prospek & Tiket',
  'menu.propinfo': 'Pusat Pengetahuan',
  'menu.rate-promos': 'Tarif & Promosi',
  'menu.finance': 'Keuangan',
  'menu.integration': 'Menghubung',
  'menu.admin': 'Admin & Keamanan',
  'menu.favourites': 'Favorit',
  'menu.recommender': 'Alur Percakapan',
  'menu.assistant-setup': 'Penyiapan Asisten',
  'menu.admin-insights': 'Wawasan Admin',
  'menu.super-admin': 'Admin Super',
  'menu.groups': 'Grup',
  'menu.properties': 'Properti',
  'menu.service-provider': 'Penyedia Layanan',
  'menu.spaces': 'Spasi',
  'menu.availability': 'Ketersediaan',
  'menu.help': 'Bantuan',
  'menu.myAccounts': 'Akun Saya',
  'menu.guest-messaging': 'Pesan Tamu',
  'guest-messaging.settings': 'Pengaturan',
  'guest-messaging.outreach-setup': 'Pengaturan Outreach',
  'guest-messaging.reservations': 'Reservasi',
  'guest-messaging.insights_logs': 'Analitik dan log',
  'guest-messaging.placeholder': 'Modul Pesan Tamu akan segera hadir.',
  'guest-messaging.settings.placeholder': 'Atur preferensi pesan tamu.',
  'guest-messaging.outreach.placeholder':
    'Siapkan kampanye dan template outreach.',
  'guest-messaging.reservations.placeholder': 'Kelola pesan reservasi.',
  'guest-messaging.reservation-source': 'Sumber Data Reservasi',
  'guest-messaging.communication-channels': 'Saluran Komunikasi',
  'guest-messaging.templates': 'Template',
  'guest-messaging.link': 'Tautan',
  'guest-messaging.business-profile': 'Profil Bisnis',

  'dashboards.space-booking': 'Pemesanan Ruang',
  'dashboards.gift-voucher': 'Voucher Hadiah',
  'dashboards.chatbots': 'bot obrolan',
  'dashboards.form': 'Dari',
  'dashboards.to': 'Ke',
  'dashboards.active-groups': 'Grup Aktif',
  'dashboards.active-properties': 'Properti Aktif',
  'dashboards.live-properties': 'Properti Langsung',
  'dashboards.properties-going':
    'Properti akan ditayangkan berdasarkan rentang tanggal',
  'dashboards.start-date': 'Tanggal Mulai',
  'dashboards.end-date': 'Tanggal Berakhir',

  'dashboards.website-visits': 'Kunjungan Situs Web',
  'dashboards.unique-visitors': 'pengunjung unik',
  'dashboards.last-week': 'Minggu lalu',
  'dashboards.this-week': 'Minggu ini',
  'dashboards.this-month': 'Bulan ini',
  'dashboards.previous-month': 'Bulan sebelumnya',
  'dashboards.yeartodate': 'Sejauh tahun ini',
  'dashboards.lastyear': 'Tahun lalu',
  'dashboards.last-7-days': '7 Hari Terakhir',
  'dashboards.last-30-days': '30 hari terakhir',
  'dashboards.last-60-days': '60 hari terakhir',
  'dashboards.last-90-days': '90 hari terakhir',
  'dashboards.conversion-rates': 'Tingkat Konversi',
  'dashboards.digital-assistant-engagement': 'Keterlibatan Asisten Digital',
  'dashboards.total-overnight-conversations':
    'Percakapan Total & Semalam (19.00 hingga 07.00).',
  'dashboards.percentage-accuracy': 'Cakupan Pengetahuan',
  'dashboards.percentage-conversion':
    'Konversi Lalu Lintas Situs Web ke Obrolan',
  'dashboards.percentage-avatarclick': 'Lalu Lintas Situs Web ke Klik Avatar',
  'dashboards.percentage-negativefeedback':
    'Masukan Negatif sebagai %usia Klik Avatar',
  'dashboards.percentage-amenties': 'Pertanyaan Fasilitas',
  'dashboards.percentage-booking': 'Pertanyaan Pemesanan',
  'dashboards.percentage-webchats': 'Obrolan Situs Web',
  'dashboards.percentage-facebookchat': 'Obrolan Facebook',
  //'dashboards.number-webchattime': 'Total Waktu Obrolan Web',

  'dashboards.number-webchattime': 'Total Waktu Percakapan',
  'dashboards.number-totalconversation': 'Total Percakapan',
  'dashboards.number-websiteconversation': 'Percakapan Situs Web',
  'dashboards.number-facebookconversation': 'Percakapan Facebook',
  'dashboards.number-estimatedtimesaving': 'Perkiraan Penghematan Waktu',
  'dashboards.number-googlemapsconversation': 'Percakapan Google Maps',
  'dashboards.number-whatsappconversation': 'Percakapan WhatsApp',
  'dashboards.number-instagramconversation': 'Percakapan Instagram',
  'dashboards.number-agentconversation': 'Percakapan Agen',
  'dashboards.number-amenityqueries': 'Pertanyaan Fasilitas',
  'dashboards.number-bookingenquiries': 'Pertanyaan Pemesanan',
  'dashboards.number-groupbookingenquiries': 'Pertanyaan Pemesanan Grup',
  'dashboards.number-eventenquiries': 'Pertanyaan Acara',
  'dashboards.number-longstayenquiries': 'Pertanyaan Tinggal Lama',
  'dashboards.number-totaltickets': 'Tiket',
  'dashboards.number-returncustomer': 'Pelanggan Kembali',
  'dashboards.number-redirects': 'Pengalihan Situs Web',
  'dashboards.number-bookingengineleads': 'Petunjuk Mesin Pemesanan',
  'dashboards.number-roomnightsreferred': 'Rujukan Malam Kamar',
  'dashboards.number-revenuereferred': 'Pendapatan yang Direferensikan',
  'menu.bookingsmenu': 'Pemesanan',
  'menu.guests': 'Informasi Tamu',
  'menu.whatsnew': 'Apa yang baru',
  'dashboards.welcomeMessage': 'Pesan Selamat Datang',
  'dashboards.personalizeGreeting':
    'Personalisasikan cara menyapa pelanggan agar mencerminkan merek, gaya, dan etiket Anda, memastikan mereka menerima sambutan hangat. Sesuaikan salam untuk mencerminkan merek Anda dan menciptakan sambutan hangat.',
  'dashboards.addRoomDetails':
    'Tambahkan detail tentang masing-masing kamar Anda agar tamu dapat dengan mudah menemukan semua yang mereka butuhkan untuk memilih yang paling cocok dan membuat proses pemesanan menjadi lebih sederhana dan cepat.',
  'dashboards.trainAIFAQs': 'Latih AI dengan FAQ',
  'dashboards.manualQuestions':
    'Beberapa pertanyaan tidak dapat dijawab melalui dokumen atau ditemukan di situs web. Di sini, Anda dapat menambahkan pertanyaan secara manual untuk memastikan pelanggan selalu memiliki informasi yang mereka butuhkan di ujung jari mereka.',
  'dashboards.publishAI': 'Terbitkan AI untuk mencerminkan pembaruan terbaru',
  'dashboards.retrainAfterChanges':
    'Ketika Anda membuat perubahan di Knowledge Hub atau formulir, pastikan untuk melatih ulang chatbot dengan informasi yang diperbarui. Mempublikasikan AI Anda memastikan chatbot memberikan jawaban yang paling akurat dan terbaru.',
  'dashboards.enhanceKnowledge':
    'Tingkatkan pengetahuan AI dengan melacak pertanyaan yang belum terjawab',
  'dashboards.reviewUnanswered':
    'Setiap kali AI tidak dapat menjawab pertanyaan atau hanya memberikan detail terbatas, Anda akan menemukan pertanyaan tersebut di sini. Tinjau untuk mengidentifikasi kekurangan di Knowledge Hub Anda atau pertanyaan tamu yang unik.',
  'dashboards.manageMedia': 'Kelola Media',
  'dashboards.mediaGallery':
    'Setiap kali Anda mengunggah gambar seperti kamar, fasilitas, logo, atau avatar digital Anda, mereka akan muncul di galeri ini, memberi Anda tempat pusat untuk mengelola visual dan memastikan tamu Anda melihat apa yang membuat bisnis Anda unik.',
  'dashboards.createForms':
    'Buat formulir dengan mudah dan dapatkan pemberitahuan setiap kali ada pengiriman.',
  'dashboards.manageForms':
    'Buat dan kelola formulir untuk mengumpulkan informasi pelanggan, atur notifikasi, dan sesuaikan untuk berbagai bahasa.',
  'dashboards.personalizeResponse':
    'Personalisasi gaya respons dan bagaimana percakapan berjalan',
  'dashboards.controlConversation':
    'Fitur canggih ini memberi Anda kemampuan untuk membentuk dan mengendalikan bagaimana percakapan berlangsung dengan pelanggan Anda di berbagai saluran.',

  'forms.forms-title': 'Membentuk',
  'menu.formbuilder': 'Pembuat formulir',
  'dashboards.trainAI': 'Latih AI dengan dokumen',
  'dashboards.uploadDocuments':
    'Unggah dokumen untuk membantu AI Anda memahami bisnis Anda dan membantu pelanggan seperti yang Anda lakukan. Anda dapat menambahkan file dalam format .doc, .pdf, atau .txt.',

  'menu.virtualfrontdesk': 'Meja Depan Virtual',
  'menu.guestservice': 'Layanan tamu',
  'virtual-front.common-questions': 'Pertanyaan Umum',
  'virtual-front.add-on-upsells': 'Add-on & Upsell',
  'virtual-front.service-order': 'Pesanan Layanan',
  //'virtual-front.guest-service-add-on-upsells': "Layanan Tamu & Pengaya",
  'virtual-front.guest-service-add-on-upsells': 'Buku Tamu Digital',
  'virtual-front.outbound': 'Keluar',
  'virtual-messenger': 'Kurir',

  'missed-response.missed-response-title': 'Judul Respons yang Dilewatkan',

  //unified inbox
  'content.allconversation': 'Semua Percakapan',
  'content.active': 'Aktif',
  'content.tickets': 'Tiket',
  'content.filter': 'Filter',
  'content.createtickets': 'Buat Tiket',
  'content.conversation': 'Percakapan',
  'content.knowledgesearch': 'Pencarian Pengetahuan',
  'content.reply': 'Balas',
  'content.visitorinfo': 'Info Pengunjung',
  'content.callinfo': 'Info Panggilan',
  'content.allinsights': 'Semua Wawasan',
  'content.availabilityrates': 'Ketersediaan & Tarif',
  'content.callback': 'Panggilan Balik',
  'content.close': 'Tutup',
  'content.sms': 'SMS',
  'content.timestamp': 'Cap Waktu',
  'content.topics': 'Topik',
  'content.callingparty': 'Pihak Pemanggil',
  'content.accountdomain': 'Domain Akun',
  'content.calledparty': 'Pihak yang Dipanggil',
  'content.recording': 'Rekaman',
  'content.phonesystemoriginationcallid': 'ID Panggilan Awal Sistem Telepon',
  'content.phonesystemterminationcallid': 'ID Panggilan Akhir Sistem Telepon',
  'content.uniqueconversationid': 'ID Percakapan Unik',
  'content.regenerateinsights': 'Regenerasi Wawasan',
  'content.customersentiment': 'Sentimen Pelanggan',
  'content.neutral': 'Netral',
  'content.customerreportedbroadbandoutage':
    'Pelanggan melaporkan gangguan broadband dengan memberikan ID pelanggan dan tanggal aktivasi layanan untuk bantuan.',
  'content.conversationinsights': 'Wawasan Percakapan',
  'content.broadbandoutage': 'Gangguan Broadband',
  'content.customeridverification': 'Verifikasi ID Pelanggan',
  'content.serviceactivationdate': 'Tanggal Aktivasi Layanan',
  'content.followups': 'Tindak Lanjut',
  'content.actionneeded': 'Tindakan Diperlukan',
  'content.uniqueConversationId': 'ID Percakapan Unik',
  'content.uniqueChatId': 'ID Obrolan Unik',
  'content.recording&transcript': 'Rekaman & Transkrip',
  'content.chatinsights': 'Wawasan Obrolan',
  'content.visitedpages': 'Halaman yang Dikunjungi',
  'content.deviceinfo': 'Info Perangkat',
  'content.chatstartedonthispage': 'Obrolan dimulai di halaman ini',
  'content.prechatinfo': 'Info sebelum obrolan',
  'content.notes': 'Catatan',
  'content.reassign': 'Tetapkan Ulang',
  'content.open': 'Buka',
  'content.dismiss': 'Tutup',
  'content.add_placeholder': 'Tambahkan nilai placeholder',
  'content.mobile_number': 'Nomor Ponsel',
  'content.please_select': 'Silakan pilih',
  'content.sendwhatsapp': 'Kirim pesan WhatsApp',

  /* Missed Response */
  'feedback.missed-question': 'Pertanyaan terlewat',
  'feedback.conversation-summary': 'Ringkasan percakapan',
  'feedback.dates-in-spanish': 'Tanggal harus dalam bahasa Spanyol',
  'feedback.resolve': 'Selesaikan',
  'feedback.ignore': 'Abaikan',
  //integration
  // id-ID
  'integration.select_properties': 'Pilih Properti',
  'integration.select_properties_enabled':
    'Pilih properti yang diaktifkan melalui integrasi ini',
  'integration.services_addons': 'Pilih Layanan & Tambahan',
  'integration.services_visible':
    'Pilih layanan & tambahan yang akan terlihat di halaman ini',
  'integration.appearance': 'Tampilan',
  'integration.appearance_customize':
    'Pilih nama asisten digital Anda, avatar, dan atur warna Anda',
  'integration.booking_calendar': 'Kalender Pemesanan',
  'integration.booking_calendar_style':
    'Pilih gaya untuk pop-up kalender pemesanan',
  'integration.nudges': 'Pengingat',
  'integration.nudges_setup':
    'Atur pesan proaktif untuk menarik pengunjung situs web',
  'integration.position': 'Posisi',
  'integration.position_control':
    'Kontrol posisi widget obrolan di situs web Anda',
  'integration.custom_fonts': 'Font Kustom',
  'integration.custom_fonts_upload':
    'Unggah font kustom yang ingin Anda gunakan di halaman',
  'integration.custom_css': 'CSS Kustom',
  'integration.custom_css_usage':
    'Gunakan CSS untuk menyesuaikan Kompendium Digital Anda',
  'integration.location': 'Lokasi',
  'integration.location_embed': 'Tambahkan URL lokasi yang disematkan',
  'integration.external_links': 'Tautan Eksternal',
  'integration.external_links_add': 'Tambahkan tautan Anda',
  'integration.language': 'Bahasa',
  'integration.widget_languages': 'Pilih bahasa untuk widget obrolan',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Aktifkan asisten digital Anda',
  'integration.chatbot_security': 'Jaga Messenger Anda Aman',
  'integration.chatbot_trusted_pages':
    'Daftar halaman tepercaya untuk menampilkan Chatbot',
  'integration.chatbot_publish': 'Publikasikan asisten digital Anda',
  'integration.chatbot_install':
    'Salin potongan kode untuk memasang asisten digital Anda',
  'integration.google_analytics': 'Pelacakan Google Analytics',
  'integration.google_analytics_desc':
    'Lacak aktivitas pengguna, sesi, dan tindakan utama di Web Widget menggunakan GA4.',
  'integration.enable_ga4': 'Aktifkan Google Analytics',
  'integration.ga4_measurement_id': 'ID Pengukuran GA4',
  'integration.ga4_id_example': 'Contoh: G-ABCD123456',
  'integration.track_events': 'Lacak Peristiwa',
  'integration.track_events_desc':
    'Pilih tindakan pengguna yang akan dikirim sebagai peristiwa GA4.',
  'integration.avatar_click': 'Klik Avatar',
  'integration.avatar_click_desc': 'Lacak saat pengguna mengklik avatar chat.',
  'integration.nudge_click': 'Klik Pengingat',
  'integration.menu_click': 'Klik Menu',
  'integration.menu_click_desc': 'Lacak saat pengguna membuka menu widget web.',
  'integration.chat_started': 'Chat Dimulai',
  'integration.chat_started_desc':
    'Lacak pesan pertama pengguna sekali per sesi.',
  'integration.event_tag': 'Tag Peristiwa',
  'integration.event_prefix': 'Awalan Peristiwa',
  'integration.final_tag': 'Tag Akhir',
  'integration.example_event': 'Contoh Peristiwa',
  'integration.once_per_session': 'Hanya sekali per sesi',
  'integration.saving': 'Menyimpan...',
  'integration.save_ga4_settings': 'Simpan Pengaturan GA4',
};
export default idMessages;
